import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import icons from './icons';

@Component({
    selector: 'app-service-icon',
    templateUrl: './service-icon.component.html',
    styleUrls: ['./service-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceIconComponent {
    public static readonly icons = icons;

    svgContent = null;

    @Input() disabled = false;
    @Input() set type(key: string) {
        const rawSvg = icons[key];
        this.svgContent = rawSvg ? this.sanitizer.bypassSecurityTrustHtml(rawSvg) : null;
    }

    constructor(private sanitizer: DomSanitizer) {}
}
